/**
 * URL du backend — SOURCE UNIQUE DE VÉRITÉ.
 *
 * En build WEB (Railway), `REACT_APP_BACKEND_URL` est injecté au build
 * (= https://api.gively.fr). En build NATIF (Capacitor / app Android), le
 * bundle embarqué (`webDir: build`) est compilé par un `npm run build` qui,
 * s'il n'a pas la variable, produisait `undefined/api` : TOUTES les requêtes
 * partaient alors vers `https://www.gively.fr/undefined/api/...`. Or
 * www.gively.fr NE sert PAS l'API — il renvoie l'app (index.html) en 200 →
 * l'app recevait du HTML au lieu du JSON → associations vides, tunnel
 * /publish qui plante (« erreur inattendue »), profil incomplet, etc.
 *
 * Garde-fou : on RETOMBE systématiquement sur l'API de PRODUCTION quand la
 * variable est absente/vide. On ne retombe JAMAIS sur `window.location.origin`
 * (= www.gively.fr) : ce domaine ne sert pas /api. Le backend est api.gively.fr.
 *
 * Vérifié en prod (2026-07-01) :
 *   GET https://api.gively.fr/api/listings  → 200 application/json  (backend)
 *   GET https://www.gively.fr/api/listings  → 200 text/html         (SPA, PAS l'API)
 */
const PROD_BACKEND_URL = "https://api.gively.fr";

const _raw = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");

export const BACKEND_URL = _raw || PROD_BACKEND_URL;

// Version applicative envoyée en en-tête X-App-Version sur chaque requête API
// (préparation au versionnement des contrats, revue pair-architecte 06/07/2026 :
// le backend n'en fait rien aujourd'hui, mais le jour où un comportement devra
// être conservé pour une ancienne app installée, l'information sera déjà là).
// SYNCHRO : prepare-android.sh la met à jour en même temps que versionName.
export const APP_VERSION = "1.3.1";
export const API_URL = `${BACKEND_URL}/api`;
